import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { ChooseIconComponent, ManageLibraryComponent } from 'vhobjects-service';
// import { ChooseIconComponent } from './../../../icon/choose-icon/choose-icon.component';
// import { ManageLibraryComponent } from '../../../../../manage-library/manage-library.component';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core'; 

@Component({
  selector: 'app-image-before-after-slider-config',
  templateUrl: './image-before-after-slider-config.component.html',
  styleUrls: ['./image-before-after-slider-config.component.scss']
})

export class AtwImageBeforeAfterSliderConfig implements OnInit{
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  style_fields = [
    {
      title: 'Bo tròn',
      index: 1,
    },
    {
      title: 'Bo tròn',
      index: 2,
    },
    {
      title: 'Bo tròn',
      index: 3,
    }
  ];

  /** Ảnh đang chọn để cấu hình ở menu HÌNH ẢNH */
  selectedImageToConfig: string = 'image__before';
  /** Icon đang chọn để cấu hình icon */
  selectedIconToConfigIcon: string = 'icon-before';
  /** Ảnh đang chọn để cấu hình filter */
  selectedImageToConfigFilter: string = 'image__before';

  subproject = null;
  id_subproject: any;
  resolution = null;
  path = '/images';
  /** Mảng chứa các thiết bị */
  devices = [
    {
      value: 'desktop',
      label: 'may_tinh',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'desktop'
    },
    {
      value: 'tablet_landscape',
      label: 'may_tinh_bang_ngang',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'tablet'
    },
    {
      value: 'tablet_portrait',
      label: 'may_tinh_bang_doc',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'tablet'
    },
    {
      value: 'mobile_landscape',
      label: 'dien_thoai_ngang',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'mobile'
    },
    {
      value: 'mobile_portrait',
      label: 'dien_thoai_doc',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'mobile'
    }
  ];


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    private matDialog: MatDialog,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {  
  }


  ngOnInit() {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(this.vhQueryAutoWeb.getlocalSubProject_Working()._id)
    this.resolution = this.subproject.resolution;
  }




  /* -------------------------------------------------------------------------- */
  /*                                UPLOAD IMAGE                                */
  /* -------------------------------------------------------------------------- */

  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary() {
    const dialogRef = this.matDialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.objectChoosing.setups.upload_image.display == 'shared') {
          this.devices.forEach(device => {
            this.staticdata[this.selectedImageToConfig][device.value + '_img'] = data.href
          })
        } else {
          this.staticdata[this.selectedImageToConfig][this.device + '_img'] = data.href
        }

        this.handleChangeConfig();
      }
      this.path = data.path;
    });
  }


  /** 
   * Hàm này dùng để mở dialog của component icon
   */
  openDialogChooseIcon() {
    const dialogRef = this.matDialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.config['slider-button'][this.selectedIconToConfigIcon + '-name'] = result.icon;
        this.updateConfig();
      }
    });
  }


  /**
   * Click mở hộp thoại chọn ảnh từ máy tính cho slider__button
   */
  openUploadSliderButton() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('uploadSliderButton').click();
  }


  /**
   * Upload ảnh từ máy tính
   * @param e Biến lưu hình ảnh
   */
  onUploadSliderButton(e) {
    const file = e.target.files[0];
    if (file) {
      this.vhImage.getThumbnailFromDesktop(file, 400, 400, "images/design/objects", null).then(
        (photoURL: any) => {
          this.config['slider-button']['image-src'] = photoURL;
          this.updateConfig();
        },
        (error) => {
          console.log('error', error);
        }
      );
    }
  }



  /* -------------------------------------------------------------------------- */
  /*                               CÁC HÀM UPDATE                               */
  /* -------------------------------------------------------------------------- */


  /**
   * hàm này để xử lý thay đổi cấu hình của hay là staticdata
   * nếu this.objectChoosing.dynamic_data = true thì cập nhật vào
   * ngược lại cập nhật vào staticdata
   */
  handleChangeConfig() {
    this.updateStaticData();
  }

  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }


  // /**
  //  * Hàm update class vào database.
  //  */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
      });
  }


  // /**
  //  * Hàm update config vào database.
  //  */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
      })
  }



  /* -------------------------------------------------------------------------- */
  /*                             TOGGLE CONFIG MENU                             */
  /* -------------------------------------------------------------------------- */

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['image-before-after-slider']['width'] = event.width + 'px';
    if (event.height) this.class['image-before-after-slider']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

}
